import { ENVIRONMENT } from '../../../environment';
import { UserApi } from '../../../services/user-api';
import { useAuthContext } from '../../../auth/auth-provider';

const { baseUrl } = ENVIRONMENT.publicGateway;

export const useUserApi = () => {
  const { getIdToken } = useAuthContext();
  return new UserApi({ baseUrl, getAuthToken: getIdToken });
};
